/**
 * Typography — Horizon Travel
 * Display: Fraunces · UI/Body: Outfit
 */

export const typography = {
  fontFamily: "'Outfit', system-ui, sans-serif",
  fontFamilyDisplay: "'Fraunces', Georgia, serif",

  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.5rem',
    '2xl': '1.875rem',
    '3xl': '2.25rem',
    '4xl': '3rem',
  },

  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  lineHeight: {
    tight: 1.15,
    snug: 1.3,
    normal: 1.5,
    relaxed: 1.65,
    loose: 2,
  },

  letterSpacing: {
    tight: '-0.03em',
    normal: '0em',
    wide: '0.04em',
  },
};

export const muiTypography = {
  fontFamily: "'Outfit', system-ui, sans-serif",

  h1: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 'clamp(2.25rem, 5vw, 3.75rem)',
    fontWeight: 600,
    lineHeight: 1.12,
    letterSpacing: '-0.03em',
  },
  h2: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h3: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h4: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '1.4rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h5: {
    fontFamily: "'Outfit', system-ui, sans-serif",
    fontSize: '1.2rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: "'Outfit', system-ui, sans-serif",
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.45,
  },
  body1: {
    fontSize: '1.05rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  body2: {
    fontSize: '0.9rem',
    fontWeight: 400,
    lineHeight: 1.55,
  },
  button: {
    fontSize: '0.95rem',
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: 'none',
    letterSpacing: '0.01em',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.7rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  subtitle1: {
    fontSize: '1.05rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '0.9rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
};

export default muiTypography;
